import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import * as reducer from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'vc-auth-button',
  templateUrl: './auth-button.component.html',
  styleUrls: ['./auth-button.component.scss']
})
export class AuthButtonComponent implements OnInit {
  @Input()
  type: string;

  constructor(private store: Store<IAppState>, public dialog: MatDialog) {}

  ngOnInit() {
    this.store.pipe(select(reducer.isAuthenticated)).subscribe(
      data => {
        this.dialog.closeAll();
      },
      () => {
        // Silent catch error because we don't have anything to do
      }
    );
  }

  openDialog() {
    const config: any = {
      disableClose: false,
      maxWidth: 1280,
      data: {
        type: this.type,
        forced: false
      }
    };
    this.dialog.open(AuthModalComponent, config);
  }
}
